<template>
  <svg
    width="55"
    height="54"
    viewBox="0 0 55 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.63896 17.2562C12.8479 9.5508 20.3666 4.52283 28.7135 4.50053C37.7095 4.45316 45.7084 10.2154 48.5126 18.7632C51.3169 27.3111 48.2857 36.6918 41.0099 41.9826C33.7341 47.2733 23.8758 47.2654 16.6085 41.963L10.1285 48.443C9.46968 49.1011 8.40235 49.1011 7.74352 48.443C7.08549 47.7842 7.08549 46.7169 7.74352 46.058L14.021 39.7805C8.1573 33.8402 6.43 24.9617 9.63896 17.2562ZM12.6475 31.8806C15.3419 38.3734 21.6839 42.6021 28.7135 42.593V42.503C38.2542 42.4909 45.9992 34.786 46.061 25.2455C46.0701 18.2159 41.8414 11.8739 35.3486 9.17957C28.8559 6.48525 21.3793 7.96992 16.4086 12.9406C11.4379 17.9113 9.95323 25.3879 12.6475 31.8806Z"
      fill="#FFDD00"
    />
  </svg>
</template>